module.exports = __webpack_public_path__ + "img/5-5.b06b280c.svg";